import { ButtonHTMLAttributes } from "react";
import s from "./style.module.scss";
import { clsx } from "clsx";

interface UIButtonpProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  fontType: "primary-1" | "primary-2" | "tertiary" | "semibold" | "medium";
  color?:
    | "green"
    | "light-green"
    | "light-green-2"
    | "white"
    | "inverted"
    | "outline";
  size?: "normal" | "thin";
}
export const UIButton = (props: UIButtonpProps) => {
  const {
    children,
    className,
    fontType,
    color = "light-green",
    size = "normal",
    ...other
  } = props;
  return (
    <button
      className={clsx(s.button, s[fontType], s[color], s[size], className)}
      {...other}
    >
      {children}
    </button>
  );
};
